var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "rename" } },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("Rename"),
            visible: _vm.dialogVisible,
            "modal-append-to-body": false,
            "close-on-click-modal": false,
            "destroy-on-close": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.viewClose,
          },
        },
        [
          _c(
            "div",
            [
              _c("el-input", {
                attrs: { placeholder: _vm.$t("enter_name"), maxlength: "30" },
                model: {
                  value: _vm.name,
                  callback: function ($$v) {
                    _vm.name = $$v
                  },
                  expression: "name",
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "border-radius": "16px" },
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      return _vm.viewClose()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Cancel")))]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { "border-radius": "16px" },
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.changeName()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("OK")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }